import { Box, Grid, Typography, Button, } from "@mui/material";
import React from "react"
import style from "./style";
import {ReactComponent as Download}from "../../../../assets/ViewLeave-images/download.svg";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer,  } from "@mui/material";
import {BalanceData} from "../../../../constants/data"

function BalanceSheet() {



  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={style.leaveHeading}>Balance Sheet</Typography>

        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          <Button variant="contained" color="success" sx={style.csvBtns} ><Download />
            {"CSV"}
          </Button>

          <Button variant="contained" color="success" sx={style.checkinBtns} ><Download />
            {"Export PDF"}
          </Button>

        </Box>
      </Box>

      <Grid container spacing={2} px="15px">
        <Grid item md={12} xs={12}>
          <Box sx={style.card}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={style.TableHead}>Liabilities</TableCell>
                    <TableCell sx={style.TableHead}>Amount($)</TableCell>
                    <TableCell sx={style.TableHead}>Assets</TableCell>
                    <TableCell sx={style.TableHead}>Amount($)</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {BalanceData.length === 0 ? (  
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <Typography variant="h6">No Data</Typography>
                      </TableCell>
                    </TableRow>
                  ) : ( 
                    BalanceData.map((item, index) => (  

                      <TableRow key={index}>
                        <TableCell sx={style.tabledatavalue}>{item?.liablities}  </TableCell>
                        <TableCell sx={style.tabledata}>{item?.amount}</TableCell>
                        <TableCell sx={style.tabledata}>{item?.assets}</TableCell>
                        <TableCell sx={style.tabledata}>{item?.amounts}</TableCell>
                        {/* <TableCell sx={styles.tabledata}></TableCell> */}
                      </TableRow>


                    )))} 
                  <TableRow>
                    <TableCell sx={style.tabledatas}>Total  </TableCell>
                    <TableCell sx={style.tabledatasvalue}>$6530</TableCell>
                    <TableCell sx={style.tabledatas}>Total</TableCell>
                    <TableCell sx={style.tabledatasvalue}>$600</TableCell>

                  </TableRow>

                </TableBody>

              </Table>


            </TableContainer>
          </Box>

        </Grid>
      </Grid>



    </>
  )
}

export default BalanceSheet;